import { NgModule } from '@angular/core';
import { FaqScreenComponent } from './faq.screen.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [FaqScreenComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ComponentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: FaqScreenComponent,
      },
    ]),
  ],
})
export class FaqScreenModule {}
